document.addEventListener("DOMContentLoaded", () => {
  const removeVariantFromUrl = () => {
    const url = new URL(window.location.href);

    if (url.searchParams.has("variant")) {
      url.searchParams.delete("variant");
      window.history.replaceState({}, "", url.pathname);
    }
  };

  removeVariantFromUrl();

  document.addEventListener("change", () => {
    setTimeout(removeVariantFromUrl, 100);
  });
});